var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningNewIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0601 19.9995H1.93994L11.9995 2.8999L22.0601 19.9995ZM4.56006 18.4995H19.4399L11.9995 5.8501L4.56006 18.4995ZM12.0298 15.73C12.6998 15.73 13.0005 16.0501 13.0005 16.6001C13.0005 17.1501 12.7198 17.4604 12.0298 17.4604C11.36 17.4604 11.0601 17.22 11.0601 16.6001C11.0601 16.0502 11.36 15.7301 12.0298 15.73ZM12.6704 14.9204H11.3296L11.0601 9.06982H12.9302L12.6704 14.9204Z",
    fill: "#F46C0B"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningNewIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Warning_New_Icon.1b84b33078512b03e5b819ece0adfd9b.svg";